import { useCartQuery } from './useCartQuery';
import { useCallback } from 'react';
import { type CartDisplay } from '@/api/registration/cart';
import { TicketData } from '@/api/registration';

export function useShoppingCart(eventId: string) {
  const {data, isFetching, isError} = useCartQuery(eventId);

  const hasTicket = useCallback((ticket: TicketData) => {
    if (data) {
      const cartItems = (data as CartDisplay).cartItems;
      if (cartItems && Array.isArray(cartItems)) {
        for (const item of cartItems) {
          if (item.productId === ticket.id && item.ticketType === ticket.type) {
            return true;
          }
        }
      }
    }
  }, [
    data,
  ]);

  // return result;
  return {
    hasTicket,
  };
}
